module.exports = __webpack_public_path__ + "static/media/kabaren.f40dd25a.png";